export const xtcommerceApp = {
  id: 103,
  name: "xtcommerce",
  label: "xt:Commerce",
  showTestConnection: true,
  logo: process.env.BASE_URL + "media/shopLogos/xtcommerce.svg",
  // "migration" = initial data import (products from the shop into Connect), which the xt:Commerce
  // preset does not offer, and there is no legacy shopimporter to take over. "reporting" has no flows
  // on the preset either.
  areaBlacklist: ["migration", "reporting"],
  // xt:Commerce 6 exposes its API through the xt_api plugin: every call is a POST to
  // index.php?page=xt_api with the API user inside the JSON body. getVersion needs nothing but valid
  // credentials, so a 200 proves URL, plugin and API user at once; wrong credentials answer 401
  // (LOGIN FAILED), a missing plugin 404. The backend substitutes {{username}} and {{password}} from
  // the credential form.
  additional_params: {
    requestHeaders: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    requestMethod: "POST",
    endpoint: "/index.php?page=xt_api",
    body: {
      function: "getVersion",
      paras: {
        user: "{{username}}",
        pass: "{{password}}"
      }
    }
  },
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_XTCOMMERCE_PRESET_ID,
    testWorkflows: {
      product: process.env?.VUE_APP_SCM_APP_TEST_PRODUCT_WORKFLOW_ID,
      salesOrder:
        process.env?.VUE_APP_SCM_APP_XTCOMMERCE_TEST_ORDER_WORKFLOW_ID,
      stock: process.env?.VUE_APP_SCM_APP_TEST_STOCK_WORKFLOW_ID,
      prices: process.env?.VUE_APP_SCM_APP_TEST_PRICES_WORKFLOW_ID,
      tracking: process.env?.VUE_APP_SCM_APP_TEST_TRACKING_WORKFLOW_ID
    },
    testBatchWorkflows: {
      salesOrder:
        process.env?.VUE_APP_SCM_APP_XTCOMMERCE_TEST_BATCH_ORDER_WORKFLOW_ID,
      tracking: process.env?.VUE_APP_SCM_APP_TEST_BATCH_TRACKING_WORKFLOW_ID
    }
  }
};
